const FRONTEND_EVENT_KEYS = {
  missionRoleApplicantPublicViewed: "MISSION_ROLE_APPLICANT_PUBLIC_VIEWED",
  missionRoleApplicantViewed: "MISSION_ROLE_APPLICANT_VIEWED",
};

const FRONTEND_EVENTABLE_TYPES = {
  missionRoleApplicant: "MISSION_ROLE_APPLICANT",
};

export { FRONTEND_EVENT_KEYS, FRONTEND_EVENTABLE_TYPES };
